<!--Navbar-->
<app-navbar appHideBreadcrumb>
    <h2> Profil candidat </h2>
</app-navbar>
<!--Header-->



<!--Empty row 50-->
<div class="empty-row-50"></div>
<!--Profile Candidate-->
<div class="candidate-details">

    <div class="container">
        <!-- <div class="row">
            <div class="col-md-12">
                <div class="back-buttons">
                    <a class="round-button green-button" routerLink="{{backButtonUrl}}">Inapoi</a>
                </div>
            </div>
        </div> -->
        <div class="col-md-12">
            <div class="row align-items-center">
                <!--Image -->
                <div class="col-md-2">
                    <div class="profile-photo-wrapper">
                        <img src='{{profilePicture}}' alt="profile photo" />
                    </div>
                </div>
                <!--Name and info info-->
                <div class="col-md-7">
                    <h1 class="candidate-name">{{userData.firstName}} {{userData.lastName}}</h1>
                    <p><b>{{userData.city}}, {{userData.userCountry}}</b></p>
                    <p *ngIf="userData.currentJob"><b>Situatie contractuala: </b>{{userData.currentJob}}</p>
                    <a class="mr-3" href="{{userData.facebookProfile}}" *ngIf="userData.facebookProfile"><i
                            class="icofont-facebook"></i></a>
                    <a class="mr-3" href="{{userData.linkedinProfile}}" *ngIf="userData.linkedinProfile"><i
                            class="icofont-linkedin"></i></a>
                    <a class="mr-3" href="{{userData.twitterProfile}}" *ngIf="userData.twitterProfile"><i
                            class="icofont-twitter"></i></a>
                    <a class="mr-3" href="{{userData.youtubeProfile}}" *ngIf="userData.youtubeProfile"><i
                            class="icofont-youtube"></i></a>
                    <a class="mr-3" href="{{userData.anotherSocialMediaAccount}}"
                        *ngIf="userData.anotherSocialMediaAccount"><i class="icofont-web"></i></a>
                </div>
                <!--                &lt;!&ndash;Contact Button&ndash;&gt;-->
                <!--                <div class="col-md-3">-->
                <!--                    <a class="orange-button">Contact</a>-->
                <!--                </div>-->
                <!--Descarca CV button-->
                <!--                <div class="col-md-3">-->
                <!--                    <a class="green-button" href="#" target="_blank">Descarca CV</a>-->
                <!--                </div>-->
            </div>
        </div>
    </div>
</div>
<!--Despre Candidat-->
<div class="about-candidate pt-50">
    <div class="container">
        <div class="row">
            <!--Left Side-->
            <div class="col-md-8">
                <div class="row">
                    <!--Educatie area-->
                    <div class="col-12 pt-10 pb-10">
                        <!--Educatie title-->
                        <div class="education-candidate-title ">
                            <h1>Educatie</h1>
                        </div>
                        <!--Educatie info-->
                        <div class="col-md-12 education-candidate pt-10 pb-10 bg-white"
                            *ngIf="userData.allUserStudies; else noEducation">
                            <div class="row" *ngFor="let education of userData.allUserStudies">
                                <!--Educatie picture-->
                                <div class="col-md-1 d-flex align-items-center">
                                    <i class="icofont-book-alt m"></i>
                                </div>
                                <div class="col-md-11">
                                    <!--Educatie phd-->
                                    <div>
                                        <div [ngSwitch]="education.userStudies">
                                            <h2 *ngSwitchCase="'faculty'">Facultate</h2>
                                            <h2 *ngSwitchCase="'high_school'">Liceu</h2>
                                            <h2 *ngSwitchCase="'college'">Colegiu</h2>
                                            <h2 *ngSwitchCase="'master'">Master</h2>
                                            <h2 *ngSwitchCase="'MBA'">MBA</h2>
                                            <h2 *ngSwitchCase="'doctorate'">Doctorat</h2>
                                        </div>
                                    </div>
                                    <div>
                                        <!--Educatie university-->
                                        <h1>{{education.studyName}}</h1>
                                    </div>
                                    <!--Educatie years and location-->
                                    <h2>{{education.studyStartDate}} - {{education.studyEndDate}}
                                        , {{education.studyLocation}}</h2>

                                </div>
                            </div>
                        </div>
                        <ng-template #noEducation>
                            <p>Nu au fost adaugate informatii.</p>
                        </ng-template>
                    </div>
                </div>
                <div class="row">
                    <!--Munca si experienta area -->
                    <div class="col-12 pb-10">
                        <!--Munca si experienta title -->
                        <div class="work-candidate-title ">
                            <h1>Munca si experienta</h1>
                        </div>
                        <!--Munca si experienta info -->
                        <div *ngIf="userData.userExperience; else noExperience">
                            <div class="col-md-12 work-candidate pt-10 pb-10 bg-white"
                                *ngFor="let experience of userData.userExperience">
                                <div class="experienceItem">
                                    <div>
                                        <!--Munca si experienta job -->
                                        <h1>{{experience.positionHeld}}</h1>
                                        <!--Munca si experienta company -->
                                        <h2><b>Companie:</b> {{experience.employer}}</h2>
                                    </div>
                                    <!--Munca si experienta years -->
                                    <h2><b>Perioada: </b>{{experience.jobStartDate}} - {{experience.jobEndDate}}</h2>
                                </div>
                                <!--Munca si experienta job description -->
                                <h3>{{experience.mainResponsibility}}</h3>
                            </div>
                        </div>
                        <ng-template #noExperience>
                            <p>Nu au fost adaugate informatii.</p>
                        </ng-template>
                    </div>
                </div>
                <div class="row">
                    <!--Despre Candidat Area-->
                    <div class="col-12">
                        <!--Despre Candidat title-->
                        <div class="about-candidate-title ">
                            <h1>Despre Candidat</h1>
                        </div>
                        <!--Despre Candidat info-->
                        <div class="col-md-12 about-candidate-text pt-5 pb-10 bg-white">
                            <div class="row" *ngIf="userData.currentJob || userData.userDepartment || userData.userActivitySector || userData.userActivitySubSector || userData.currentExperienceLevel || userData.jobType || userData.desiredLevelOfJob || userData.availableForWork; else noExperience">
                                <div class="col-md-6" *ngIf="userData.currentJob">
                                    <p><b>Status job
                                            actual: </b> {{userData.currentJob | enumTransform}} </p>
                                </div>
                                <div class="col-md-6" *ngIf="userData.userDepartment">
                                    <p>
                                        <b>Departament: </b> {{userData.userDepartment | enumTransform}}
                                    </p>
                                </div>
                                <div class="col-md-6" *ngIf="userData.userActivitySector">
                                    <p>
                                        <b>Domeniu: </b> {{userData.userActivitySector | enumTransform}}
                                    </p>
                                </div>
                                <div class="col-md-6" *ngIf="userData.userActivitySubSector">
                                    <p>
                                        <b>Subdomeniu: </b> {{userData.userActivitySubSector | enumTransform}}
                                    </p>
                                </div>
                                <div class="col-md-6" *ngIf="userData.currentExperienceLevel">
                                    <p><b>Nivelul experientei
                                            actuala: </b> {{userData.currentExperienceLevel | enumTransform}} </p>
                                </div>
                                <div class="col-md-6" *ngIf="userData.jobType">
                                    <p><b>Tip job: </b> {{userData.jobType | enumTransform}} </p>
                                </div>
                                <div class="col-md-6" *ngIf="userData.desiredLevelOfJob">
                                    <p><b>Nivel de job
                                            dorit: </b> {{userData.desiredLevelOfJob | enumTransform}} </p>
                                </div>
                                <div class="col-md-6" *ngIf="userData.availableForWork">
                                    <p><b>Disponibilitate
                                            angajare: </b> {{userData.availableForWork | enumTransform}} </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!--Mobilitate geografica Area-->
                    <div class="col-12">
                        <!--Mobilitate geografica title-->
                        <div class="about-candidate-title ">
                            <h1>Mobilitate geografica</h1>
                        </div>
                        <!--Mobilitate geografica info-->
                        <div class="col-md-12 about-candidate-text pt-5 pb-10 bg-white">
                            <div class="row" *ngIf="userData.regionOfInterest || userData.availabilityOfRelocation || userData.driverLicense || userData.userAvailableForTraveling || userData.workPermissionInEu; else noExperience">
                                <div class="col-md-6" *ngIf="userData.regionOfInterest">
                                    <p><b>Regiune de
                                            interes: </b> {{userData.regionOfInterest | enumTransform}} </p>
                                </div>
                                <div class="col-md-6" *ngIf="userData.availabilityOfRelocation">
                                    <p><b>Disponibilitate de
                                            relocare: </b> {{userData.availabilityOfRelocation | enumTransform}} </p>
                                </div>
                                <div class="col-md-6" *ngIf="userData.driverLicense">
                                    <p><b>Permis de conducere: </b> {{userData.driverLicense}} </p>
                                </div>
                                <div class="col-md-6" *ngIf="userData.userAvailableForTraveling">
                                    <p><b>Disponibilitate de
                                            deplasare: </b> {{userData.userAvailableForTraveling | enumTransform}} </p>
                                </div>
                                <div class="col-md-6" *ngIf="userData.workPermissionInEu">
                                    <p><b>Permis de munca in
                                            UE: </b> {{userData.workPermissionInEu | enumTransform}} </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row pb-10" *ngIf="userData.linkVideoCV">
                    <div class="col-md-12">
                        <div class="about-candidate-title ">
                            <h1>Video CV</h1>
                        </div>
                        <iframe width="100%" height="315" [src]="videoCV | safe">
                        </iframe>
                    </div>
                </div>

                <div class="row">
                    <!--Brand de candidat Area-->
                    <div class="col-12">
                        <!--Brand de candidat title-->
                        <div class="about-candidate-title ">
                            <h1>Brandul tau de candidat</h1>
                        </div>
                        <!--Brand de candidat info-->
                        <div class="col-md-12 about-candidate-text pt-5 pb-10 bg-white">
                            <div class="row" *ngIf="userData.certification || userData.award || userData.top || userData.recommendation || userData.volunteering || userData.socialAction; else noExperience">
                                <div *ngIf="userData.certification.length !== 0 || userData.award.length !== 0 || userData.top.length !== 0 || userData.recommendation.length !== 0 || userData.volunteering.length !== 0 || userData.socialAction.length !== 0; else noExperience">
                                <div class="col-md-12" *ngIf="userData.certification.length !== 0">
                                    <p><b>Certificari (optional) : </b></p>
                                    <div *ngFor="let item of userData.certification | keyvalue; let i=index;"
                                        class="d-inline-flex mb-3">
                                        <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3">
                                            Vezi fisier {{i + 1}} </a>
                                    </div>
                                </div>
                                <div class="col-md-12" *ngIf="userData.award.length !== 0">
                                    <p><b>Premii / Distinctii (optional): </b></p>
                                    <div *ngFor="let item of userData.award | keyvalue;  let i=index;"
                                        class="d-inline-flex mb-3">
                                        <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3">
                                            Vezi fisier {{i + 1}} </a>
                                    </div>
                                </div>
                                <div class="col-md-12" *ngIf="userData.top.length !== 0">
                                    <p><b>Clasamente, topuri (optional): </b></p>
                                    <div *ngFor="let item of userData.top | keyvalue; let i=index;"
                                        class="d-inline-flex mb-3">
                                        <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3">
                                            Vezi fisier {{i + 1}} </a>
                                    </div>
                                </div>
                                <div class="col-md-12" *ngIf="userData.recommendation.length !== 0">
                                    <p><b>Testimoniale/ recomandari: </b></p>
                                    <div *ngFor="let item of userData.recommendation | keyvalue; let i=index;"
                                        class="d-inline-flex mb-3">
                                        <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3">
                                            Vezi fisier {{i + 1}} </a>
                                    </div>
                                </div>
                                <div class="col-md-12" *ngIf="userData.volunteering.length !== 0">
                                    <p><b>Voluntariat: </b></p>
                                    <div *ngFor="let item of userData.volunteering | keyvalue; let i=index;"
                                        class="d-inline-flex mb-3">
                                        <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3">
                                            Vezi fisier {{i + 1}} </a>
                                    </div>
                                </div>
                                <div class="col-md-12" *ngIf="userData.socialAction.length !== 0">
                                    <p><b>Implicare in actiuni sociale: </b></p>
                                    <div *ngFor="let item of userData.socialAction | keyvalue; let i=index;"
                                        class="d-inline-flex mb-3">
                                        <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3">
                                            Vezi fisier {{i + 1}} </a>
                                    </div>
                                </div>
                                <div class="col-md-12" *ngIf="userData.certification.length !== 0">
                                    <p><b>Hobby-uri si realizari personale: </b></p>
                                    <div *ngFor="let item of userData.certification | keyvalue; let i=index;"
                                        class="d-inline-flex mb-3">
                                        <a href="{{item.value.link}}" target="_blank" class="btn btn-secondary mr-3">
                                            Vezi fisier {{i + 1}} </a>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!--Cunostinte Area-->
                    <div class="col-12">
                        <!--Cunostinte title-->
                        <div class="about-candidate-title ">
                            <h1>Cunostinte</h1>
                        </div>
                        <!--Cunostinte info-->
                        <div class="col-md-12 about-candidate-text pt-5 pb-10 bg-white">
                            
                            <div class="pb-5" *ngIf="userData.otherCourses || userData.pcKnowledge">
                                <p *ngIf="userData.otherCourses"><b>Alte cursuri/ formari: </b> {{userData.otherCourses}} </p>
                                <p *ngIf="userData.pcKnowledge"><b>Cunostinte PC: </b> {{userData.pcKnowledge}} </p>
                            </div>

                                <div>
                                    <h1>Limbi straine:</h1>
                                    <div *ngIf="userData.foreignLanguage; else noExperience">
                                        <div class="limbi-straine"
                                        *ngFor="let item of userData.foreignLanguage | keyvalue">
                                        <p class="col-md-12">{{item.value.language}} - {{item.value.level}}</p>
                                    </div>
                                    </div>
                                </div>
                            
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!--Jobul Ideal Area-->
                    <div class="col-12">
                        <!--Jobul Ideal title-->
                        <div class="about-candidate-title ">
                            <h1>Jobul Ideal</h1>
                        </div>
                        <!--Jobul Ideal info-->
                        <div class="col-md-12 about-candidate-text pt-10 pb-10 bg-white">
                            <div class="row pb-10">
                                <div class="col-md-12">
                                    <h1 class="pb-5">Pachet salarial ideal</h1>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <p><b>Salariu minim: </b> {{userData.minimumSalary}}
                                                euro/luna</p>
                                        </div>
                                        <div class="col-md-6">
                                            <p><b>Interesat de sisteme
                                                    bonusare: </b> {{userData.interestedInBonusSystem | enumTransform}}
                                            </p>
                                        </div>
                                        <div class="col-md-6">
                                            <p><b>Bonuri de masa
                                                    obligatorii: </b> {{userData.mandatoryMealVoucher | enumTransform}}
                                            </p>
                                        </div>
                                        <div class="col-md-6">
                                            <p><b>Bonuri de vacanta
                                                    obligatorii: </b> {{userData.mandatoryHolidayVoucher |
                                                enumTransform}} </p>
                                        </div>
                                        <div class="col-md-6">
                                            <p><b>Masina de serviciu
                                                    obligatorie: </b> {{userData.mandatoryServiceCar | enumTransform}}
                                            </p>
                                        </div>
                                        <div class="col-md-6">
                                            <p><b>Pachet de sanatate
                                                    obligatoriu: </b> {{userData.mandatoryHealthPackage |
                                                enumTransform}} </p>
                                        </div>
                                        <div class="col-md-6">
                                            <p><b>Masa
                                                    obligatorie: </b> {{userData.mandatoryFood | enumTransform}} </p>
                                        </div>
                                        <div class="col-md-6">
                                            <p><b>Cazare
                                                    obligatorie: </b> {{userData.mandatoryAccommodation |
                                                enumTransform}} </p>
                                        </div>
                                        <div class="col-md-6">
                                            <p><b>Cursuri in
                                                    tara: </b> {{userData.coursesInTheCountry | enumTransform}} </p>
                                        </div>
                                        <div class="col-md-6">
                                            <p><b>Cursuri in afara
                                                    tarii: </b> {{userData.coursesAboard | enumTransform}} </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row pb-10">
                                <div class="col-md-12">
                                    <h1 class="pb-5">Conditii de lucru ideale</h1>
                                    <div class="row" *ngIf="userData.userWorkProgram || userData.userWorkSpace || userData.physicalEffortAvailability || userData.weightLiftingAvailability || userData.workTemperature || userData.userCommute; else noExperience">
                                        <div class="col-md-6" *ngIf="userData.userWorkProgram">
                                            <p><b>Program de lucru</b> {{userData.userWorkProgram | enumTransform}} </p>
                                        </div>
                                        <div class="col-md-6" *ngIf="userData.userWorkSpace">
                                            <p><b>Spatiu de lucru: </b> {{userData.userWorkSpace | enumTransform}} </p>
                                        </div>
                                        <div class="col-md-6" *ngIf="userData.physicalEffortAvailability">
                                            <p><b>Disponibilitate efort fizic: </b>
                                                {{userData.physicalEffortAvailability | enumTransform}} </p>
                                        </div>
                                        <div class="col-md-6" *ngIf="userData.weightLiftingAvailability">
                                            <p><b>Disponibilitate ridicare
                                                    greutati: </b> {{userData.weightLiftingAvailability |
                                                enumTransform}} </p>
                                        </div>
                                        <div class="col-md-6" *ngIf="userData.workTemperature">
                                            <p><b>De acord sa lucrezi la diferite
                                                    temeperaturi: </b> {{userData.workTemperature | enumTransform}} </p>
                                        </div>
                                        <div class="col-md-6" *ngIf="userData.userCommute">
                                            <p><b>Esti dispus sa faci
                                                    naveta?: </b> {{userData.userCommute | enumTransform}} </p>
                                        </div>
                                        <div class="col-md-6"><p><b>De acord sa lucrezi la diferite
                                            temperaturi: </b> {{userData.workTemperature | enumTransform}} </p></div>
                                        <div class="col-md-6"><p><b>Esti dispus sa faci
                                            naveta?: </b> {{userData.userCommute | enumTransform}} </p></div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <h1 class="pb-5">Conditii de lucru ideale</h1>
                                    <div *ngIf="userData.idealCompany || userData.idealJob || userData.idealBenefits; else noExperience">
                                        <p *ngIf="userData.idealCompany"><b>Compania ideala: </b> <span [innerHTML]="userData.idealCompany"></span> </p>
                                        <p *ngIf="userData.idealJob"><b>Jobul ideal: </b> <span [innerHTML]="userData.idealJob"></span> </p>
                                        <p *ngIf="userData.idealBenefits"><b>Beneficii ideale: </b> <span [innerHTML]="userData.idealBenefits"></span> </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row pb-10">
                    <!--Abilitati Area-->
                    <div class="col-12">
                        <!--Abilitati title-->
                        <div class="about-candidate-title ">
                            <h1>Abilitati</h1>
                        </div>
                        <!--Abilitati info-->
                        <div class="col-md-12 about-candidate-text pt-5 pb-10 bg-white">
                            <div class="row" *ngIf="userData.ability; else noExperience">
                                <div *ngFor="let skill of userData.ability" class="col-md-12 pb-10">
                                    <p *ngIf="skill.abilityName"><b>Abilitate: </b> {{skill.abilityName | uppercase}} </p>
                                    <p *ngIf="skill.abilityDescription"><b>Descriere abilitate: </b> {{skill.abilityDescription}} </p>
                                    <p *ngIf="skill.abilityLevel"><b>Nivel abilitate: </b> {{skill.abilityLevel}} </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--Right Side-->
            <div class="col-md-4 pt-10 pb-10">
                <div class="row">
                    <!--Sumar Candidat area-->
                    <div class="col-md-12">
                        <!--Sumar Candidat title-->
                        <div class="sumar-candidate-title ">
                            <h1>Sumar profil candidatura</h1>
                        </div>
                        <!--Sumar Candidat info-->
                        <div class="sumar-candidate-text pt-10 pb-10 bg-white">
                            <!--Empty row 10-->
                            <div class="empty-row-10"></div>
                            <!--Wanted payment info-->
                            <div class="col-md-12 wanted-payment d-flex flex-column" *ngIf="userData.minimumSalary">
                                <div class="wanted-payment-title d-flex flex-row">
                                    <!--Wanted payment icon-->
                                    <i class="icofont-credit-card"></i>
                                    <!--Wanted payment name-->
                                    <h3>Salariul dorit</h3>
                                </div>
                                <!--Wanted payment value-->
                                <span>{{userData.minimumSalary}} euro/luna</span>
                            </div>
                            <!--Empty row 10-->
                            <div class="empty-row-10"></div>
                            <!--Gender info-->
                            <div class="col-md-12 gender d-flex flex-column" *ngIf="userData.gender">
                                <div class="gender-title d-flex flex-row">
                                    <!--Gender icon-->
                                    <i class="icofont-users-alt-4"></i>
                                    <!--Gender name-->
                                    <h3>Gen</h3>
                                </div>
                                <!--Gender value-->
                                <span *ngIf="userData.gender == 'male'">Barbat</span>
                                <span *ngIf="userData.gender == 'female'">Femeie</span>
                            </div>
                            <!--Empty row 10-->
                            <div class="empty-row-10"></div>
                            <!--Languages info-->
                            <div class="col-md-12 languages d-flex flex-column" *ngIf="userData.foreignLanguage">
                                <div class="languages-title d-flex flex-row">
                                    <!--Languages icon-->
                                    <i class="icofont-book"></i>
                                    <!--Languages name-->
                                    <h3>Limbi straine</h3>
                                </div>
                                <!--Languages value-->
                                <div *ngFor="let lang of userData.foreignLanguage">
                                    <span>{{lang.language}}</span>
                                </div>

                            </div>
                            <!--Empty row 10-->
                            <div class="empty-row-10"></div>
                            <!--Studies info-->
                            <div class="col-md-12 studies d-flex flex-column" *ngIf="userData.allUserStudies">
                                <div class="studies-title d-flex flex-row">
                                    <!--Studies icon-->
                                    <i class="icofont-papers"></i>
                                    <!--Studies name-->
                                    <h3>Nivel educatie</h3>
                                </div>
                                <!--Studies value-->
                                <div *ngFor="let study of userData.allUserStudies">
                                    <div [ngSwitch]="study.userStudies">
                                        <span *ngSwitchCase="'faculty'">Facultate</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12" *ngIf="dataLoaded && userCanEdit">
                        <div class="sumar-candidate-title">
                            <h1>Profil comportamental</h1>
                        </div>
                        <!--Sumar Candidat info-->
                        <div class="sumar-candidate-text index-person bg-white">
                            <form (ngSubmit)="onSubmit(indexCandidate)" #indexCandidate="ngForm">
                                <p>Profil comportamental</p>
                                <a target="_blank"
                                    href="{{userData.candidateProfilePdf['link']}}">{{userData.candidateProfilePdf.name}}</a>
                                <input type="file" (change)="uploadPDFAttachment($event, 'candidate')">
                                <p>Profilul postului</p>
                                <a target="_blank" class="d-block" *ngFor="let pdf of userData.jobProfilePdf"
                                    href="{{pdf['link']}}">{{pdf.name}}</a>
                                <input type="file" (change)="uploadPDFAttachment($event, 'job')">
                                <p>Indice persoana</p>

                                <select [(ngModel)]="userData.indexCandidate.indexPerson" class="form-control"
                                    name="indexPerson">
                                    <option *ngFor="let ind of profileIndex" value="{{ind}}">{{ind}}</option>
                                </select>
                                <p>Indice job</p>
                                <select [(ngModel)]="userData.indexCandidate.indexJob" class="form-control"
                                    name="indexJob">
                                    <option *ngFor="let ind of profileIndex" value="{{ind}}">{{ind}}</option>
                                </select>
                                <p>Matching index</p>
                                <input [(ngModel)]="userData.indexCandidate.matchingIndex" type="number"
                                    class="form-control" name="matchingIndex">
                                <p>Denumire post</p>
                                <input [(ngModel)]="userData.indexCandidate.jobName" type="text" class="form-control"
                                    name="jobName">
                                <p>Descriere DISC</p>
                                <textarea [(ngModel)]="userData.indexCandidate.discDescription" class="form-control"
                                    name="discDescription">
                            </textarea>

                                <button type="submit" class="send-button round-button green-background form-control">
                                    {{'BUTTONS.SEND' | translate}}
                                </button>

                                <app-form-message [success]="formResponse"
                                    [customSuccessMessage]="'Informatii modificate cu succes.'"
                                    [customErrorMessage]="'Ceva nu a functionat bine, te rog verifica campurile'"
                                    *ngIf="formSent"></app-form-message>
                            </form>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<!--Footer-->
<app-footer></app-footer>
